import { BarWave } from 'react-cssfx-loading';
import { useTranslation } from 'react-i18next';

import './style.scss';

interface LoadingProps {
  label?: string;
  color?: string;
  width?: number | string;
  height?: number | string;
  duration?: string;
  className?: string;
}

export const Loading = ({
  label,
  color = 'var(--primary)',
  width,
  height,
  duration,
  className
}: LoadingProps) => {
  const { t } = useTranslation();
  const accessibleLabel = label ?? t('common.label.loading');

  return (
    <div
      className={['dec-loading', className].filter(Boolean).join(' ')}
      role="status"
      aria-label={accessibleLabel}>
      <BarWave color={color} width={width} height={height} duration={duration} aria-hidden="true" />
    </div>
  );
};
